import React, { FC, useEffect, useState } from 'react'
import Popup from 'reactjs-popup'
import { PopupActions, PopupProps } from 'reactjs-popup/dist/types'
import CloseIcon from '../../UI/Icons/Close';
import './Popup.scss'

//merging two interaces
interface ICustomProps {
  isShowPopup?: boolean
  customRefProp?: React.MutableRefObject<PopupActions | undefined>
  updateTrigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | any
  buttonClose?: () => void
  isOpen?: boolean
}

interface ICustomPopupProps extends PopupProps, ICustomProps {}
//merging two interaces

// TODO clear popup
const CustomPopup: FC<ICustomPopupProps> = ({
  children,
  isShowPopup,
  buttonClose,
  updateTrigger,
  customRefProp,
  ...props
}) => {
  const [settings, setSettings] = useState<any>()

  useEffect(() => {
    const settingsToState = {
      className: 'custom-popup',
      position: ['top left', 'bottom left'],
      closeTimeoutMS: 2000,
      ...props
    }

    if (isShowPopup) settingsToState.on = ['hover']

    setSettings(settingsToState)

    return () => {
      if (isShowPopup) settingsToState.on = ['hover']
      setSettings({})
    }
    // TODO CHANGE MODAL WINDOW
    // eslint-disable-next-line
  }, [props.open, props.isOpen, props.on, isShowPopup, updateTrigger])

  return (
    <Popup {...settings} ref={customRefProp}>
      {buttonClose && <div onClick={buttonClose} className='close-button'><CloseIcon/></div>}
      <div className='popup'>{children}</div>
    </Popup>
  )
}

export default CustomPopup
